import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import en from 'vuetify/lib/locale/en';
import ru from 'vuetify/lib/locale/ru';
import OpenTofuIcon from '@/components/OpenTofuIcon.vue';
import PulumiIcon from '@/components/PulumiIcon.vue';
import TerragruntIcon from '@/components/TerragruntIcon.vue';
import HashicorpVaultIcon from '@/components/HashicorpVaultIcon.vue';
import DvlsIcon from '../components/DvlsIcon.vue';
import AwsSmIcon from '../components/AwsSmIcon.vue';
import AzureKvIcon from '../components/AzureKvIcon.vue';

Vue.use(Vuetify);

// ZetaPilot brand palette — indigo brand hue 268°. Source of truth is
// `styles/tokens.scss` (OKLCH). Vuetify v2 only accepts hex/rgb so we
// hand-translate the corresponding OKLCH values once here. If you change
// a colour, update both files.
//
// Status colours pull from `--zp-status-*` whenever a component renders
// outside the Vuetify theme runtime (zp-status badge, dashboard widgets).
// Hex values are OKLCH-translated; see styles/tokens.scss for the canonical OKLCH.
const zetaLight = {
  primary: '#5A60C5',
  secondary: '#5D6477',
  accent: '#5A60C5',
  info: '#3F73C8',
  success: '#2B8C5A',
  warning: '#B07C28',
  error: '#C04A33',
  anchor: '#5A60C5',
};

// Dark theme keeps the SAME indigo hue as light — just lifted lightness so
// it stays AA on dark surfaces. Don't pastel-shift to lavender; that breaks
// brand recognition across themes (the original symptom: dark-theme buttons
// look like a different product than light-theme buttons).
const zetaDark = {
  primary: '#7079D6',
  secondary: '#9498AC',
  accent: '#7079D6',
  info: '#6E94D9',
  success: '#4FAB78',
  warning: '#C99850',
  error: '#D67560',
  // Anchor matches primary so links read at the same visual weight as
  // primary actions; the previous lavender shift made links louder than
  // buttons, inverting the cockpit hierarchy.
  anchor: '#7079D6',
};

// Sync Vuetify's component-internal strings (data-table footer, pagination,
// rating, etc.) with the saved app language. main.js drives the initial
// language; updates from the language switcher should also call
// `vuetify.framework.lang.current = lang`.
const storedLang = (typeof localStorage !== 'undefined' && localStorage.getItem('lang')) || 'ru';

export default new Vuetify({
  lang: {
    locales: { en, ru },
    current: storedLang === 'ru' ? 'ru' : 'en',
  },
  theme: {
    themes: {
      light: zetaLight,
      dark: zetaDark,
    },
    options: {
      // Expose --v-primary-base CSS variables so non-Vuetify components
      // (custom Vue templates, plain CSS) can reuse the brand colour.
      customProperties: true,
    },
  },
  icons: {
    values: {
      tofu: {
        component: OpenTofuIcon,
      },
      pulumi: {
        component: PulumiIcon,
      },
      terragrunt: {
        component: TerragruntIcon,
      },
      hashicorp_vault: {
        component: HashicorpVaultIcon,
      },
      dvls: {
        component: DvlsIcon,
      },
      aws_sm: {
        component: AwsSmIcon,
      },
      azure_kv: {
        component: AzureKvIcon,
      },
    },
  },
});
